import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=72739f46&scoped=true&lang=pug&"
var script = {}
import style0 from "./BaseTooltip.vue?vue&type=style&index=0&id=72739f46&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72739f46",
  null
  
)

export default component.exports